import React from "react";

const AbilityTestContent = () => {
  return (
    <div>
      <h1 className="text-primary mb-3 m-5">
        Ability Tests And Certifications
      </h1>
      <div className="container">
        <h4>Coming Soon Stay Tuned...</h4>
        <div class="row">
          <div class="card-deck mb-4">
            <div class="card">
              <div class="card-body">
                <h5 class="card-title">Java</h5>
                <p class="card-text">
                  Java is a popular, high-level programming language known for
                  its platform independence, object-oriented features, and
                  extensive class libraries.
                </p>
                <p class="card-text">
                  <small class="text-muted">Last updated 3 days ago</small>
                </p>
              </div>
            </div>
            <div class="card">
              <div class="card-body">
                <h5 class="card-title">Javascript</h5>
                <p class="card-text">
                  JavaScript is a widely-used, high-level programming language
                  that is primarily used to add interactivity and dynamic
                  functionality to web pages.
                </p>
                <p class="card-text">
                  <small class="text-muted">Last updated 3 days ago</small>
                </p>
              </div>
            </div>
            <div class="container card">
              <div class="card-body">
                <h5 class="card-title">SQL</h5>
                <p class="card-text">
                  SQL, or Structured Query Language, is a programming language
                  used to manage and manipulate relational databases by querying
                  and modifying data stored within them.
                </p>
                <p class="card-text">
                  <small class="text-muted">Last updated 3 days ago</small>
                </p>
              </div>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="card-deck mb-4">
            <div class="card">
              <div class="card-body">
                <h5 class="card-title">Collection API</h5>
                <p class="card-text">
                  Java Collection API is a framework that provides a set of
                  interfaces, implementations, and algorithms for managing and
                  manipulating groups of objects in Java.
                </p>
                <p class="card-text">
                  <small class="text-muted">Last updated 3 days ago</small>
                </p>
              </div>
            </div>
            <div class="card">
              <div class="card-body">
                <h5 class="card-title">Spring</h5>
                <p class="card-text">
                  Spring Framework is a popular, open-source application
                  framework for building enterprise-level Java applications that
                  provides a comprehensive programming and configuration model
                  for modern Java-based enterprise applications.
                </p>
                <p class="card-text">
                  <small class="text-muted">Last updated 3 days ago</small>
                </p>
              </div>
            </div>
            <div class="container card">
              <div class="card-body">
                <h5 class="card-title">Hibernate</h5>
                <p class="card-text">
                  Hibernate Framework is a powerful, open-source
                  object-relational mapping tool for Java that simplifies the
                  process of mapping an object-oriented domain model to a
                  traditional relational database.
                </p>
                <p class="card-text">
                  <small class="text-muted">Last updated 3 days ago</small>
                </p>
              </div>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="card-deck mb-4">
            <div class="card">
              <div class="card-body">
                <h5 class="card-title">React</h5>
                <p class="card-text">
                  React JS is a popular, open-source JavaScript library for
                  building user interfaces that emphasizes component-based
                  development, reusability, and virtual DOM rendering for
                  increased performance.
                </p>
                <p class="card-text">
                  <small class="text-muted">Last updated 3 days ago</small>
                </p>
              </div>
            </div>
            <div class="card">
              <div class="card-body">
                <h5 class="card-title">Angular</h5>
                <p class="card-text">
                  Angular is a popular, open-source TypeScript-based framework
                  for building dynamic web applications that provides a robust
                  set of features for building complex, data-driven UIs also
                  known as Single Page Appilications (SPAs).
                </p>
                <p class="card-text">
                  <small class="text-muted">Last updated 3 days ago</small>
                </p>
              </div>
            </div>
            <div class="container card">
              <div class="card-body">
                <h5 class="card-title">Java 8 features</h5>
                <p class="card-text">
                  Java 8 features include lambda expressions, functional
                  interfaces, default and static methods in interfaces, method
                  references, streams, and the new Date and Time API, among
                  others, which greatly enhance the expressiveness and
                  functionality of the language.
                </p>
                <p class="card-text">
                  <small class="text-muted">Last updated 3 days ago</small>
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AbilityTestContent;
